module.exports = __webpack_public_path__ + "img/icon-globe-white.4ed6098c.svg";